import { LoadingContainer, LoadingText, Spinner } from "./LoginLoading.styles"

const LoginLoading = ({ message = 'Loading...' }) => {
  return (
    <LoadingContainer>
      <Spinner />
      <LoadingText>{message}</LoadingText>
    </LoadingContainer>
  )
}

export default LoginLoading
